module.exports = __webpack_public_path__ + "img/tu-marcador.8062e21a.png";